import { signal, computed, Injectable } from "@angular/core";
import { WkDataTableColumn, WkDataTableDynamicColumn, WkDataTableSimpleColumn } from "@components/data-table/columns";
import type { WkDataTableColumnsByField, WkDataTableStateColumns } from "@components/data-table/data-table.types";

@Injectable()
export class WkDataTableRegistryService {
    private readonly columnsByField = signal<WkDataTableColumnsByField>(new Map());

    public readonly list = computed(() => Array.from(this.columnsByField().values()));

    public initialize(columns: readonly WkDataTableColumn<any>[], states: WkDataTableStateColumns | undefined): void {
        const columnsByField: WkDataTableColumnsByField = new Map();
        columns.forEach((column) => {
            if (typeof column === "object" && column instanceof WkDataTableDynamicColumn) {
                (column as WkDataTableDynamicColumn<any, any>).columns().forEach((subColumn) => {
                    const state = states?.[subColumn.fullFieldName()];
                    if (state) subColumn.setState(state);
                    columnsByField.set(subColumn.fullFieldName(), subColumn);
                });
            } else {
                const castedColumn = column as WkDataTableSimpleColumn<any, any>;
                const state = states?.[column.definition.fieldname];
                if (state) castedColumn.setState(state);
                columnsByField.set(column.definition.fieldname, castedColumn);
            }
        });
        this.columnsByField.set(columnsByField);
    }

    public get(fieldname: string): WkDataTableSimpleColumn<any, any> | undefined {
        return this.columnsByField().get(fieldname);
    }
}
